import io from 'socket.io/client-dist/socket.io'
import config from './config';

class Connection {

    async connect(password, roomName) {
        return new Promise((resolve, reject) => {

            this.connection = io(config.api, {
                query: {
                    password,
                    boardName: roomName
                }
            })

            this.connection.on('connected', (e) => resolve(e))
            this.connection.on('unauthenticated', () => reject('Unauthenticated'));
            this.connection.on('authentication_error', (e) => reject(`Board '${roomName}' does not exist`));

            this.connection.on(roomName + '_disconnected', (e) => this.onDisconnected(e))
            this.connection.on(roomName + '_object_create', (e) => this.onObjectCreated(e))
            this.connection.on(roomName + '_object_update', (e) => this.onObjectUpdated(e))
            this.connection.on(roomName + '_object_delete', (e) => this.onObjectDelete(e))
            this.connection.on(roomName + '_settings_update', (e) => this.onSettingsUpdated(e))
            this.connection.on(roomName + '_mouse_update', (e) => this.onMouseUpdated(e))
        })
    }

    setCanvas(canvas) {
        this.canvas = canvas;
    }

    onDisconnected(e) {
        alert('You have been disconnected from the server.');
    }

    onObjectCreated(e) {
        this.canvas.onObjectCreated(e);
    }

    onObjectUpdated(e) {
        this.canvas.onObjectUpdated(e);
    }

    onObjectDelete(e) {
        this.canvas.onObjectDeleted(e);
    }

    onSettingsUpdated(e) {
        this.canvas.onSettingsUpdated(e);
    }

    onMouseUpdated(e) {
        this.canvas.onMouseUpdated(e);
    }

    emit(event, data) {
        this.connection.emit(event, data);
    }

    disconnect() {
        this.connection.disconnect();
    }
}

export default Connection;



// WEBPACK FOOTER //
// ./src/Connection.js